import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import BasePage from '@ts-core/pages/BasePage';

import DoAssignment from 'modules/assignments/components/DoAssignment';

import { Assignment } from '../../types';
import { useAssignmentActions } from '../../hooks';

export const DoAssignmentPage = () => {
  const history = useHistory();
  const [assignment, setAssignment] = useState<Assignment>();

  const { courseId, assignmentId } = useParams<{ courseId: string; assignmentId: string }>();

  const { onSendAssignmentAnswer, sendAssignmentAnswerLoading, onStartAssignment, startAssignmentLoading } = useAssignmentActions({
    courseId,
  });

  useEffect(() => {
    onStartAssignment(assignmentId, (assignment: Assignment) => {
      setAssignment(assignment);
    });
  }, [onStartAssignment, assignmentId]);

  const handleSendAssignment = useCallback(
    (input: Record<string, any>) => {
      onSendAssignmentAnswer(assignmentId, input, () => {
        history.replace('details');
      });
    },
    [onSendAssignmentAnswer, assignmentId, history]
  );

  return (
    <BasePage>
      <DoAssignment
        assignment={assignment}
        loading={startAssignmentLoading || !assignment}
        onSendAssignment={handleSendAssignment}
        isSubmittingAssignmentAnswer={sendAssignmentAnswerLoading}
      />
    </BasePage>
  );
};

export default DoAssignmentPage;
